module.exports = __webpack_public_path__ + "static/media/twitter.88c38bdc.svg";